(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5407],{

/***/ 39298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ CurationDrawer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/SwipeableDrawer/SwipeableDrawer.js + 2 modules
var SwipeableDrawer = __webpack_require__(39005);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardHeader/CardHeader.js + 1 modules
var CardHeader = __webpack_require__(78445);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(87952);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardMedia/CardMedia.js + 1 modules
var CardMedia = __webpack_require__(83965);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardActions/CardActions.js + 1 modules
var CardActions = __webpack_require__(62023);
// EXTERNAL MODULE: ./assets/icon/heart-outline.png
var heart_outline = __webpack_require__(56615);
var heart_outline_default = /*#__PURE__*/__webpack_require__.n(heart_outline);
// EXTERNAL MODULE: ./assets/icon/heart-filled.png
var heart_filled = __webpack_require__(97112);
var heart_filled_default = /*#__PURE__*/__webpack_require__.n(heart_filled);
// EXTERNAL MODULE: ./node_modules/react-lines-ellipsis/lib/index.modern.mjs
var index_modern = __webpack_require__(6870);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./service/Curation.js
var Curation = __webpack_require__(64473);
;// CONCATENATED MODULE: ./components/Product/CurationCard.js










const CurationCard = (param)=>{
    let { curation , handleClick , session , setAuthOpen  } = param;
    var _curation_owner_image;
    const [favourites, setFavourites] = (0,react.useState)([]);
    const [favourited, setFavourited] = (0,react.useState)(curation.user_list_favourites != null);
    const [favCount, setFavCount] = (0,react.useState)(curation.favourites_count);
    (0,react.useEffect)(()=>{
        setFavourites(curation.user_list_favourites ? [
            curation.user_list_favourites
        ] : []);
    }, [
        curation
    ]);
    const handleFavClick = async (e)=>{
        e.stopPropagation();
        if (session === null) {
            setAuthOpen(true);
        } else {
            let list_favourites = favourites;
            let user = session.user;
            if (list_favourites.length) {
                let pf = list_favourites[0];
                pf.favourite = false;
                let res = await (0,Curation/* UpdateListFavourite */.ru)(pf, session);
                list_favourites = favourites.filter((list_favourites)=>pf.id !== list_favourites.id);
                let cur = {
                    ...curation
                };
                setFavourites([]);
                cur.user_list_favourites = [];
                cur.favourites_count -= 1;
                setFavourited(false);
                setFavCount((favCount)=>favCount -= 1);
            // setCuration(cur);
            } else {
                let res1 = await (0,Curation/* CreateListFavourite */.zf)({
                    faved_by: user.id,
                    m_list: curation.id
                }, session);
                let cur1 = {
                    ...curation
                };
                cur1.user_list_favourites = [
                    res1.data
                ];
                cur1.favourites_count += 1;
                setFavourites([
                    res1.data
                ]);
                setFavCount((favCount)=>favCount += 1);
                setFavourited(true);
            // setCuration(cur);
            // updateProducts(product);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        sx: {
            p: 1.5,
            borderRadius: 3,
            border: "1px solid #E9E7ED",
            boxShadow: "none"
        },
        onClick: ()=>{
            handleClick(curation.slug);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                sx: {
                    pt: 0,
                    px: 0,
                    pb: 1,
                    ["& .MuiCardHeader-avatar"]: {
                        marginRight: 1
                    }
                },
                avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    sx: {
                        width: "22px",
                        height: "22px"
                    },
                    src: (_curation_owner_image = curation.owner.image) === null || _curation_owner_image === void 0 ? void 0 : _curation_owner_image.file,
                    alt: curation.owner.name
                }),
                title: curation.owner.name,
                titleTypographyProps: {
                    variant: "smallText"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia/* default */.Z, {
                component: "img",
                height: "auto",
                // width="138"
                sx: {
                    borderRadius: "6px"
                },
                image: curation.image.file,
                alt: curation.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                sx: {
                    px: 0,
                    py: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "smallText",
                    color: "rgba(0, 0, 0, 0.6)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.Z, {
                        text: curation.title,
                        maxLine: "1",
                        ellipsis: "...",
                        trimRight: true,
                        basedOn: "letters"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                sx: {
                    p: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    gap: 0.5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            onClick: handleFavClick,
                            src: favourited ? (heart_filled_default()) : (heart_outline_default()),
                            alt: "favorite"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "smallText",
                            children: [
                                favCount,
                                " favourites"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./service/products.js
var products = __webpack_require__(37766);
// EXTERNAL MODULE: ./assets/icon/Curly-hair-bro.png
var Curly_hair_bro = __webpack_require__(60187);
var Curly_hair_bro_default = /*#__PURE__*/__webpack_require__.n(Curly_hair_bro);
// EXTERNAL MODULE: ./assets/icon/circle_on_your.png
var circle_on_your = __webpack_require__(973);
var circle_on_your_default = /*#__PURE__*/__webpack_require__.n(circle_on_your);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroller/index.js
var react_infinite_scroller = __webpack_require__(246);
var react_infinite_scroller_default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller);
// EXTERNAL MODULE: ./components/LoadingSpinner/PaginationLoader.js + 1 modules
var PaginationLoader = __webpack_require__(20967);
// EXTERNAL MODULE: ./context/ScrollRestorationContext.js
var ScrollRestorationContext = __webpack_require__(42341);
// EXTERNAL MODULE: ./service/PlayoffService.js
var PlayoffService = __webpack_require__(96085);
// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/esm/index.esm.js + 2 modules
var index_esm = __webpack_require__(56467);
// EXTERNAL MODULE: ./context/ScrollContext.js
var ScrollContext = __webpack_require__(79854);
;// CONCATENATED MODULE: ./components/Product/CurationDrawer.js

















const CurationDrawer = (param)=>{
    let { session , status , setOpen , open , curationsCount , otherCurations , setCurationsCount , setAuthOpen  } = param;
    const [id, setId] = (0,react.useState)(null);
    const [playoff, setPlayoff] = (0,react.useState)(curationsCount != null ? curationsCount.latest_playoff : null);
    const [product, setProduct] = (0,react.useState)(null);
    const [curations, setCurations] = (0,react.useState)([]);
    const [fetching, setFetching] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(true);
    const [currPage, setCurrPage] = (0,react.useState)(1);
    const [hasMore, setHasMore] = (0,react.useState)(true);
    const { updateTrayItems  } = (0,react.useContext)(ScrollContext/* ScrollContext */.$);
    const router = (0,next_router.useRouter)();
    const scrollContainerRef = (0,react.useRef)(null);
    const handleCurationCardClick = async (slug)=>{
        setOpen(false);
        setCurationsCount({
            ...curationsCount,
            scrollTo: scrollContainerRef.current.scrollTop
        });
        updateTrayItems({
            ...curationsCount,
            scrollTo: scrollContainerRef.current.scrollTop,
            excuted: false
        });
        router.push("/curation/".concat(slug));
    };
    const getScrollParent = (element)=>{
        if (!element) return null;
        const style = window.getComputedStyle(element);
        const overflowRegex = /(auto|scroll)/;
        if (overflowRegex.test(style.overflow) || overflowRegex.test(style.overflowX) || overflowRegex.test(style.overflowY)) {
            return element;
        }
        return getScrollParent(element.parentNode);
    };
    const [count, setCount] = (0,react.useState)(curationsCount === null || curationsCount === void 0 ? void 0 : curationsCount.count);
    const fetchItems = (0,react.useCallback)(async ()=>{
        var _curationsCount_drawerCurations;
        if (fetching || id === null) {
            return;
        }
        if (((_curationsCount_drawerCurations = curationsCount.drawerCurations) === null || _curationsCount_drawerCurations === void 0 ? void 0 : _curationsCount_drawerCurations.length) && curationsCount.excuted != true) {
            setCurations(curationsCount.drawerCurations);
            setCurrPage(curationsCount.currPage);
            setHasMore(curationsCount.hasMore);
            setCurationsCount({
                ...curationsCount,
                excuted: true
            });
            if (curationsCount.scrollTo) {
                let interval = setInterval(()=>{
                    if (scrollContainerRef.current) {
                        clearInterval(interval);
                        scrollContainerRef.current.scroll({
                            top: curationsCount.scrollTo,
                            behavior: "auto"
                        });
                    }
                }, 500);
            }
            // scrollContainerRef.current.scrollTo(0,curationsCount.scrollTo)
            // setFetching(true);
            return;
        }
        setFetching(true);
        try {
            let res = await (0,products/* getProductsCurations */.gV)(id, currPage, session);
            let new_curations = res.data.curations;
            // setCurations(curations.results);
            // setCount(res.data.count);
            const next = new_curations.has_next;
            setPlayoff(res.data.latest_playoff);
            setProduct(res.data.product);
            setCurations([
                ...curations,
                ...new_curations.results
            ]);
            if (next) {
                setCurrPage(currPage + 1);
            }
            setHasMore(next);
            setCurationsCount({
                ...curationsCount,
                currPage: currPage + 1,
                hasMore: next,
                drawerCurations: [
                    ...curations,
                    ...new_curations.results
                ]
            });
            updateTrayItems({
                ...curationsCount,
                currPage: currPage + 1,
                hasMore: next,
                drawerCurations: [
                    ...curations,
                    ...new_curations.results
                ]
            });
        } catch (error) {
            setHasMore(false);
        } finally{
            setFetching(false);
        }
    }, [
        curations,
        fetching,
        hasMore,
        id
    ]);
    const getData = async ()=>{
        if (curationsCount.id == !null) {
            let res = await (0,products/* getProductsCurations */.gV)(curationsCount.id, 1, session);
            // setCurations([]);
            console.log("====================================");
            console.log(res.data);
            console.log("====================================");
            setProduct(res.data.product);
            setCount(res.data.count);
            setLoading(false);
            setPlayoff(res.data.latest_playoff);
        } else {
            setLoading(false);
        }
    };
    const handleCurateButton = ()=>{
        if (!session) {
            setAuthOpen(true);
            return;
        } else {
            localStorage.setItem("playoff_id", playoff.id);
            localStorage.setItem("products", JSON.stringify([
                {
                    id: product.id,
                    selected: true
                }
            ]));
            router.push("/playoff/".concat(playoff.slug, "/products"));
        }
    };
    const handleAskYourTribeButton = async ()=>{
        let url = product.image.file.replace("https://d2h50zujfkj84t.cloudfront.net", "https://grape-images-bucket.s3.ap-south-1.amazonaws.com");
        const blob = await fetch(url).then((r)=>r.blob());
        const shareddata = {
            title: product.name,
            text: "Hey, discovered this product on Grape with various styling options by awesome curators. Would love to know how you'd style it!",
            url: playoff.deeplink,
            files: [
                new File([
                    blob
                ], "file.png", {
                    type: blob.type
                })
            ]
        };
        if (navigator.canShare && navigator.canShare(shareddata)) {
            let data = {
                playoff: playoff.id
            };
            if (!session) {
                let auth = (0,index_esm/* getAuth */.v0)();
                let user = auth.currentUser;
                data.uid = user.uid;
            } else {
                let user1 = session.user;
                data = {
                    playoff: playoff.id,
                    shared_by: user1.id
                };
            }
            let list = await (0,PlayoffService/* UpdatePlayOffShare */.wk)(data, session);
            navigator.share(shareddata).then(()=>console.log("Successful share")).catch((error)=>console.log("Error sharing", error));
        } else {
            console.log("====================================");
            console.log("not supporting");
            console.log("====================================");
        }
    // localStorage.setItem("playoff_id", playoff.id);
    // localStorage.setItem(
    // 	"products",
    // 	JSON.stringify([{ id: product, selected: true }])
    // );
    // router.push(`/playoff/${playoff.slug}/products`);
    };
    (0,react.useEffect)(()=>{
        if (curationsCount !== null) {
            setId(curationsCount.id);
            setCurations([]);
            setCurrPage(1);
            setHasMore(true);
            setFetching(false);
            setProduct(null);
            setCount(curationsCount.count);
            // setLoading(false)
            getData();
        // setCurations([]);
        }
    }, [
        open,
        session,
        status
    ]);
    const theme = (0,useTheme/* default */.Z)();
    const isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    // const [open, setOpen] = useState(true);
    const containerRef = (0,react.useRef)(null);
    let mobileCss = !isMobile ? {
        width: 480,
        left: "50%",
        transform: "translate(-50%)"
    } : {
        width: "100%"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipeableDrawer/* default */.Z, {
        sx: {
            transition: "transform 300ms ease-in-out",
            ...mobileCss
        },
        transitionDuration: {
            enter: 300,
            exit: 195
        },
        PaperProps: {
            square: false,
            sx: {
                borderRadius: "24px 24px 0px 0px",
                height: "calc(100% - 90px)",
                overflow: "auto"
            }
        },
        anchor: "bottom",
        open: open,
        onClose: ()=>{
            setId(null);
            setOpen(false);
            setLoading(true);
        },
        onOpen: ()=>{},
        slotProps: {
            backdrop: {
                style: {
                    backgroundColor: "rgba(0, 0, 0, 0.7)"
                }
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            style: {
                height: "100%",
                overflow: "hidden"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        width: 48,
                        height: 6,
                        backgroundColor: "rgba(0, 0, 0, 0.2)",
                        borderRadius: 3,
                        marginX: "auto",
                        // position: "absolute",
                        marginTop: 1.5,
                        marginBottom: 1.75
                    }
                }),
                loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationLoader/* PaginationLoader */.X, {
                    shimmertype: "product_card",
                    pageNumber: 1,
                    mX: 0,
                    isListingScreen: false
                }, "loaderrr-1") : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    p: 2.5,
                    ref: scrollContainerRef,
                    sx: {
                        height: "calc(100%)",
                        overflow: "auto"
                    },
                    children: id !== null && count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h2_new",
                                        component: "h2",
                                        sx: {
                                            textTransform: "capitalize"
                                        },
                                        children: "From the Grapevine"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        component: "p",
                                        variant: "body2_light",
                                        pt: 1,
                                        children: [
                                            count,
                                            " ways to style this product from our community"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_infinite_scroller_default()), {
                                pageStart: currPage,
                                loadMore: fetchItems,
                                hasMore: hasMore,
                                useWindow: false,
                                getScrollParent: ()=>getScrollParent(scrollContainerRef.current),
                                loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationLoader/* PaginationLoader */.X, {
                                    shimmertype: "product_card",
                                    pageNumber: 1,
                                    mX: 0,
                                    isListingScreen: false
                                }, "loaderrr-1"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    container: true,
                                    pt: 2.5,
                                    spacing: 1.5,
                                    mb: 4,
                                    children: curations.map((curation, i)=>{
                                        if (i == 3 || curations.length < 4 && i == curations.length - 1) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        item: true,
                                                        xs: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurationCard, {
                                                            session: session,
                                                            setAuthOpen: setAuthOpen,
                                                            curation: curation,
                                                            handleClick: handleCurationCardClick
                                                        })
                                                    }, i),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        item: true,
                                                        xs: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                                            sx: {
                                                                // mt: 4,
                                                                borderRadius: 2,
                                                                border: "1px solid #E9E7ED",
                                                                boxShadow: "0px 4px 10px -6px rgba(0, 0, 0, 0.12)"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                                                                sx: {
                                                                    textAlign: "center",
                                                                    py: 4
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                        variant: "h2_new",
                                                                        component: "h2",
                                                                        sx: {
                                                                            textAlign: "center",
                                                                            textTransform: "capitalize"
                                                                        },
                                                                        children: [
                                                                            "Add",
                                                                            " ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                                variant: "h2_new",
                                                                                sx: {
                                                                                    position: "relative"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        style: {
                                                                                            position: "absolute",
                                                                                            left: "-7px",
                                                                                            top: "-5px"
                                                                                        },
                                                                                        src: (circle_on_your_default())
                                                                                    }),
                                                                                    "your"
                                                                                ]
                                                                            }),
                                                                            " ",
                                                                            "take to the grapevine"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                                        marginTop: 4,
                                                                        paddingBottom: 0,
                                                                        direction: "row",
                                                                        justifyContent: "space-around",
                                                                        alignItems: "center",
                                                                        spacing: 1,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                                sx: {
                                                                                    padding: "12px 0px"
                                                                                },
                                                                                variant: "contained",
                                                                                fullWidth: true,
                                                                                // size={"large"}
                                                                                onClick: handleCurateButton,
                                                                                children: "Curate Yourself"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                                onClick: handleAskYourTribeButton,
                                                                                variant: "outlined",
                                                                                fullWidth: true,
                                                                                sx: {
                                                                                    padding: "12px 0px"
                                                                                },
                                                                                children: "Ask your tribe"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, i);
                                        }
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurationCard, {
                                                session: session,
                                                setAuthOpen: setAuthOpen,
                                                curation: curation,
                                                handleClick: handleCurationCardClick
                                            })
                                        }, i);
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (Curly_hair_bro_default()),
                                alt: "empty card"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h1",
                                component: "h1",
                                children: "Be the first one to Curate"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                sx: {
                                    mt: 4,
                                    borderRadius: 2,
                                    border: "1px solid #E9E7ED",
                                    boxShadow: "0px 4px 10px -6px rgba(0, 0, 0, 0.12)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                                    sx: {
                                        textAlign: "center",
                                        py: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "h2_new",
                                            component: "h2",
                                            sx: {
                                                textAlign: "center",
                                                textTransform: "capitalize"
                                            },
                                            children: [
                                                "Add",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    sx: {
                                                        position: "relative"
                                                    },
                                                    children: "your"
                                                }),
                                                " ",
                                                "take to the grapevine"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                            marginTop: 4,
                                            direction: "row",
                                            justifyContent: "space-around",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    sx: {
                                                        padding: "12px 0px"
                                                    },
                                                    variant: "contained",
                                                    fullWidth: true,
                                                    // size={"large"}
                                                    onClick: handleCurateButton,
                                                    children: "Curate Yourself"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    onClick: handleAskYourTribeButton,
                                                    variant: "outlined",
                                                    fullWidth: true,
                                                    sx: {
                                                        padding: "12px 0px"
                                                    },
                                                    children: "Ask your tribe"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 95407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ ProductCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 58 modules
var Tooltip = __webpack_require__(99332);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(87952);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 5 modules
var Badge = __webpack_require__(71236);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./assets/images/Rectangle 3.png
var Rectangle_3 = __webpack_require__(10689);
// EXTERNAL MODULE: ./assets/icon/heart-outline.png
var heart_outline = __webpack_require__(56615);
var heart_outline_default = /*#__PURE__*/__webpack_require__.n(heart_outline);
// EXTERNAL MODULE: ./assets/icon/heart-filled.png
var heart_filled = __webpack_require__(97112);
var heart_filled_default = /*#__PURE__*/__webpack_require__.n(heart_filled);
// EXTERNAL MODULE: ./assets/icon/collageicon.png
var collageicon = __webpack_require__(5286);
// EXTERNAL MODULE: ./components/Product/CurationDrawer.js + 1 modules
var CurationDrawer = __webpack_require__(39298);
// EXTERNAL MODULE: ./service/products.js
var products = __webpack_require__(37766);
// EXTERNAL MODULE: ./node_modules/react-lottie/dist/index.js
var dist = __webpack_require__(79464);
;// CONCATENATED MODULE: ./assets/animation/curations_final.json
var curations_final_namespaceObject = JSON.parse('{"v":"4.8.0","meta":{"g":"LottieFiles AE 3.4.5","a":"","k":"","d":"","tc":""},"fr":60,"ip":0,"op":61,"w":31,"h":31,"nm":"curations_final","ddd":0,"assets":[{"id":"comp_0","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Line 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[3.5,8.5,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-3,0],[3,0]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Line 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Line 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[9.5,5.5,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-3,0],[3,0]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Line 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Line 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[6,6.5,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-6,0],[6,0]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":90,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Line 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"icon","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[6.5,6.5,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[13,13],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":2,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"icon","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":0,"nm":"icon","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[15.5,15.5,0],"ix":2},"a":{"a":0,"k":[6.5,6.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":13,"h":13,"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Ellipse 30","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[15.5,15.5,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[28,28],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"gs","o":{"a":0,"k":100,"ix":9},"w":{"a":0,"k":2,"ix":10},"g":{"p":3,"k":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[0,0.494,0.153,0.945,0.5,0.741,0.357,0.912,1,0.988,0.561,0.878]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":15,"s":[0,0.494,0.153,0.945,0.5,0.361,0.433,0.933,1,0.227,0.714,0.922]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":30,"s":[0,0.494,0.153,0.945,0.5,0.741,0.357,0.912,1,0.988,0.561,0.878]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":45,"s":[0,0.494,0.153,0.945,0.5,0.361,0.433,0.933,1,0.227,0.714,0.922]},{"t":60,"s":[0,0.494,0.153,0.945,0.5,0.741,0.357,0.912,1,0.988,0.561,0.878]}],"ix":8}},"s":{"a":0,"k":[13.176,0],"ix":4},"e":{"a":0,"k":[-14,0],"ix":5},"t":1,"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":13},"bm":0,"nm":"Gradient Stroke 1","mn":"ADBE Vector Graphic - G-Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":15,"s":[90]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":30,"s":[180]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":45,"s":[270]},{"t":60,"s":[360]}],"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 30","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0}],"markers":[]}');
// EXTERNAL MODULE: ./context/ScrollContext.js
var ScrollContext = __webpack_require__(79854);
;// CONCATENATED MODULE: ./components/Product/ProductCard.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	0% { background-image:linear-gradient(270deg, #7E27F1 2.94%, #FC8FE0 100%) }\n	25% { background-image:linear-gradient(360deg, #7E27F1 0%, #3AB6EB 100%)}\n	50% { background-image:linear-gradient(90deg, #7E27F1 2.94%, #FC8FE0 100%)}\n	100% { background-image:linear-gradient(270deg, #7E27F1 2.94%, #FC8FE0 100%) }\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}













const ProductCard = (param)=>{
    let { product , curation =null , handleViews , session , status , setAuthOpen , setOpen , setCurationsCount , handleFavorite =null , showTooltip =false  } = param;
    var _product_image, _product_seller, _product_curation_count;
    const options = {
        animationData: curations_final_namespaceObject,
        loop: true
    };
    const myKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject());
    const { updateTrayItems  } = (0,react.useContext)(ScrollContext/* ScrollContext */.$);
    const [favorites, setFavorites] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        setFavorites(product.product_favourite);
    }, [
        product
    ]);
    const handleCollageClick = ()=>{
        let { curation_count  } = product;
        setCurationsCount(curation_count);
        updateTrayItems(curation_count);
        setOpen(true);
    };
    const handleFavoriteClick = async ()=>{
        if (handleFavorite != null) {
            let { product_favourite  } = product;
            handleFavorite(product_favourite[0].id);
            return;
        }
        if (status === "authenticated") {
            let { product_favourite: product_favourite1  } = product;
            let user = session.user;
            if (product_favourite1.length) {
                let pf = favorites[0];
                pf.favourite = false;
                let res = await (0,products/* UpdateProductFavourite */.Wb)(pf, session);
                product.product_favourite = product.product_favourite.filter((product_favourite)=>pf.id !== product_favourite.id);
                setFavorites(product.product_favourite.filter((product_favourite)=>pf.id !== product_favourite.id));
            // updateProducts(product);
            } else {
                let res1 = await (0,products/* CreateProductFavourite */.sx)({
                    product: product.id,
                    faved_by: user.id,
                    m_list: curation === null || curation === void 0 ? void 0 : curation.id
                }, session);
                product.product_favourite = [
                    res1.data
                ];
                setFavorites([
                    res1.data
                ]);
            // updateProducts(product);
            }
        } else {
            setAuthOpen(true);
        }
    };
    // const handleProductView = async () => {
    // 	window.open(product.url, "_blank", "noreferrer");
    // 	let { product_views } = product;
    // 	if (product_views.length) {
    // 		let index=-1
    // 		if(curation!=null){
    // 			index=product_views.findIndex(({m_list})=>m_list=curation.id)
    // 		}
    // 		product_view=index=-1?product_views[0]:
    // 		product_view.views += 1;
    // 		// let res = await UpdateProductView(product_view);
    // 		product.product_views[0] = res.data;
    // 		// updateProducts(product);
    // 		// window.open(product.url, "_blank", "noreferrer");
    // 	} else {
    // 		let input_data = {
    // 			product: product.id,
    // 			m_list: curation?.id,
    // 		};
    // 		if (isAuthenticated) {
    // 			let user = session.user;
    // 			input_data.viewed_by = user.id;
    // 		} else {
    // 			let currentUser = getAuth().currentUser;
    // 			input_data.uid = currentUser?.uid;
    // 		}
    // 		// let res = await CreateProductView(input_data);
    // 		product.product_views = [res.data];
    // 		// updateProducts(product);
    // 		// window.open(product.url, "_blank", "noreferrer");
    // 	}
    // };
    // console.log(product.product_favourite);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            item: true,
            xs: 6,
            sx: {
                flexShrink: "0,",
                position: "relative"
            },
            children: [
                showTooltip == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    open: true,
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        color: "white",
                        sx: {
                            padding: 0.5
                        },
                        children: "Tap to Shop"
                    }),
                    arrow: true,
                    PopperProps: {
                        sx: {
                            zIndex: 0,
                            "& .MuiTooltip-tooltip": {
                                borderRadius: "10px",
                                backgroundColor: "#3AB6EB"
                            },
                            "& .MuiTooltip-arrow": {
                                color: "#3AB6EB"
                            }
                        }
                    },
                    placement: "top",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            position: "absolute",
                            left: "35%",
                            top: "12%",
                            width: "35px"
                        }
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    onClick: ()=>{
                        handleViews(product);
                    },
                    sx: {
                        border: 1,
                        backgroundColor: "white",
                        borderColor: "grayColor.main",
                        borderRadius: "8px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            variant: "square",
                            alt: product === null || product === void 0 ? void 0 : product.name,
                            src: product === null || product === void 0 ? void 0 : (_product_image = product.image) === null || _product_image === void 0 ? void 0 : _product_image.file,
                            sx: {
                                width: "100%",
                                height: 216,
                                borderRadius: "8px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            m: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    direction: "row",
                                    sx: {
                                        mt: "8px"
                                    },
                                    children: product.discount_price !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: "body2",
                                                children: [
                                                    "₹",
                                                    product.discount_price
                                                ]
                                            }),
                                            product.original_price - product.discount_price > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: "smallText2",
                                                        sx: {
                                                            marginX: "3px",
                                                            textDecoration: "line-through",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            opacity: 0.5
                                                        },
                                                        children: [
                                                            "₹",
                                                            product.original_price
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: "smallText2",
                                                        color: "primary",
                                                        sx: {
                                                            display: "flex",
                                                            alignItems: "center"
                                                        },
                                                        children: [
                                                            Math.round(100 * (product.original_price - product.discount_price) / product.original_price),
                                                            "% OFF"
                                                        ]
                                                    })
                                                ]
                                            }) : ""
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: [
                                            "₹",
                                            product.original_price
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        lineHeight: "16px",
                                        mt: "5px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "smallText",
                                        sx: {
                                            opacity: 0.65,
                                            display: "-webkit-box",
                                            overflow: "hidden",
                                            WebkitBoxOrient: "vertical",
                                            WebkitLineClamp: 2,
                                            height: "32px"
                                        },
                                        children: product.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        marginY: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "smallText",
                                        children: (_product_seller = product.seller) === null || _product_seller === void 0 ? void 0 : _product_seller.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    mt: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        // onClick={() => {
                                        // 	handleViews(product);
                                        // }}
                                        disableElevation: true,
                                        fullWidth: true,
                                        // href={product.url}
                                        // target="_blank"
                                        color: "shopNowButton",
                                        variant: "contained",
                                        sx: {
                                            borderRadius: 2,
                                            height: "40px",
                                            backgroundColor: "primary.main",
                                            color: "white",
                                            backgroundColor: "primary.main",
                                            color: "white"
                                        },
                                        children: "Visit store"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    spacing: 1,
                    sx: {
                        position: "absolute",
                        margin: 1,
                        marginTop: 3.5,
                        marginRight: 1.5,
                        top: 0,
                        right: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            disableRipple: true,
                            disableFocusRipple: true,
                            sx: {
                                backgroundColor: "white",
                                height: 28,
                                width: 28
                            },
                            onClick: ()=>{
                                handleFavoriteClick();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (favorites === null || favorites === void 0 ? void 0 : favorites.length) ? (heart_filled_default()) : (heart_outline_default()),
                                alt: "favorite"
                            })
                        }),
                        product.is_collage_icon_show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                badgeContent: (_product_curation_count = product.curation_count) === null || _product_curation_count === void 0 ? void 0 : _product_curation_count.count,
                                sx: {
                                    "& .MuiBadge-badge": {
                                        fontSize: 9,
                                        zIndex: 0,
                                        // borderRadius:"50%",
                                        height: 15,
                                        // minWidth: 15,
                                        bottom: "5px",
                                        right: "4px"
                                    }
                                },
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "right"
                                },
                                color: "primary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    onClick: handleCollageClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        options: options,
                                        isClickToPauseDisabled: true
                                    })
                                })
                            })
                        }) : null
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 64473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BU": function() { return /* binding */ CreateRating; },
/* harmony export */   "DD": function() { return /* binding */ getFavouriteDetails; },
/* harmony export */   "EN": function() { return /* binding */ curationDetails; },
/* harmony export */   "HT": function() { return /* binding */ getProductsForCuration; },
/* harmony export */   "g": function() { return /* binding */ UpdateListView; },
/* harmony export */   "jc": function() { return /* binding */ UpdateCurationShare; },
/* harmony export */   "ru": function() { return /* binding */ UpdateListFavourite; },
/* harmony export */   "uv": function() { return /* binding */ CreateCuration; },
/* harmony export */   "zf": function() { return /* binding */ CreateListFavourite; }
/* harmony export */ });
/* unused harmony exports curationDetailsWithoutUser, getCategoryDetails, CreateListView */
/* harmony import */ var _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71287);

const CreateCuration = async (data, token1)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token1);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.post */ .be.post("/api/communitylist/", data, {
        headers: headers
    });
    return res;
};
let endpoint = "api/communitylist/";
const curationDetails = async (id, session)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(session);
    const res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.get */ .be.get("".concat(endpoint).concat(id), {
        headers: headers
    }).catch((error)=>error);
    // console.log(res);
    return res;
};
const curationDetailsWithoutUser = async (id, uid)=>{
    let headers = AuthHeader();
    const res = await axiosInstance.get("api/curation/".concat(id), {
        params: {
            uid: uid
        },
        headers: headers
    });
    // console.log(res);
    return res;
};
const getProductsForCuration = async (ids, uuid, pk, token1)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token1);
    try {
        const res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.post */ .be.post("api/curation-products/".concat(pk), {
            ids: ids,
            uuid: uuid
        }, {
            headers: headers
        });
        console.log(res);
        return {
            status: true,
            products: res.data.products,
            success: ""
        };
    } catch (error) {
        console.log("====================================");
        console.log(error);
        console.log("====================================");
        return {
            status: false,
            products: [],
            error: "Something went wrong! Try refresh the page"
        };
    }
};
const getCategoryDetails = async (id)=>{
    let res = await axiosInstance.get("/api/categories/".concat(id));
    return res;
};
const UpdateListFavourite = async (data, token1)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token1);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.put */ .be.put("feed/list-fav/".concat(data.id, "/"), data, {
        headers: headers
    });
    return res;
};
const CreateListFavourite = async (data, token1)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token1);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.post */ .be.post("feed/list-fav/", data, {
        headers: headers
    });
    return res;
// return ;
};
const CreateListView = async (data)=>{
    let headers = setHeader(token);
    let res = await axiosInstance.post("feed/list-view/", data, {
        headers: headers
    });
    return res;
// return ;
};
const UpdateListView = async (data, token1)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token1);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.post */ .be.post("feed/list_views_update/", data, {
        headers: headers
    });
    return res;
};
const getFavouriteDetails = async (data, token1)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token1);
    const res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.get */ .be.get("api/curation/".concat(data.curation, "/feed"), {
        params: data,
        headers: headers
    });
    // console.log(res);
    return res;
};
const UpdateCurationShare = async (data, token1)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token1);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.post */ .be.post("feed/list_share_update/", data, {
        headers: headers
    });
    return res;
};
const CreateRating = async (data, token1)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token1);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.post */ .be.post("api/list-rating/", data, {
        headers: headers
    });
    return res;
};


/***/ }),

/***/ 96085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dc": function() { return /* binding */ getAllCurationsbyPlayOff; },
/* harmony export */   "Fx": function() { return /* binding */ playoffListdetails; },
/* harmony export */   "Jl": function() { return /* binding */ getCurationsbyUser; },
/* harmony export */   "N3": function() { return /* binding */ UpdatePlayOffView; },
/* harmony export */   "O5": function() { return /* binding */ getGroupProducts; },
/* harmony export */   "Te": function() { return /* binding */ getplayoffs; },
/* harmony export */   "Z_": function() { return /* binding */ getAllCurationsbyCategory; },
/* harmony export */   "kT": function() { return /* binding */ getCurationsbyOthers; },
/* harmony export */   "o4": function() { return /* binding */ playoffdetails; },
/* harmony export */   "wk": function() { return /* binding */ UpdatePlayOffShare; }
/* harmony export */ });
/* harmony import */ var _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71287);

let endpoint = "api/playoff/";
const playoffdetails = async function(id) {
    let product = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, products = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    const res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.get */ .be.get("".concat(endpoint).concat(id), {
        params: {
            product: product,
            products: products
        }
    }).catch((error)=>error);
    return res;
};
const playoffListdetails = async (id)=>{
    const res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.get */ .be.get("api/playoff-details/".concat(id, "/")).catch((error)=>error);
    return res;
};
const getGroupProducts = async function(group) {
    let page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    const res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.get */ .be.get("api/group/".concat(group, "/products"), {
        params: {
            page_size: 10,
            page: page
        }
    });
    return res;
};
const getplayoffs = async function(token) {
    let page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    const res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.get */ .be.get(endpoint, {
        params: {
            page_size: 5,
            page: page
        }
    });
    // console.log(res);
    return res;
};
const UpdatePlayOffView = async (data, token)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.post */ .be.post("feed/playoff_views_update/", data, {
        headers: headers
    });
    return res;
};
const UpdatePlayOffShare = async (data, token)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.post */ .be.post("feed/playoff_share_update/", data, {
        headers: headers
    });
    return res;
};
const getCurationsbyUser = async function(token, id) {
    let page = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.get */ .be.get("api/playoff/curation/".concat(id), {
        headers: headers,
        params: {
            page_size: 5,
            page: page
        }
    });
    return res;
};
const getCurationsbyOthers = async function(token, id) {
    let page = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.get */ .be.get("api/playoff/curation/others/".concat(id), {
        headers: headers,
        params: {
            page_size: 5,
            page: page
        }
    });
    return res;
};
const getAllCurationsbyPlayOff = async function(token, id) {
    let page = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.get */ .be.get("api/playoff/all/".concat(id), {
        headers,
        params: {
            page_size: 5,
            page: page
        }
    });
    return res;
};
const getAllCurationsbyCategory = async function(token, id) {
    let page = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.get */ .be.get("api/category/".concat(id, "/curation"), {
        headers,
        params: {
            page_size: 5,
            page: page
        }
    });
    return res;
};


/***/ }),

/***/ 37766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E9": function() { return /* binding */ CreateProductView; },
/* harmony export */   "I": function() { return /* binding */ UpdateProductView; },
/* harmony export */   "Wb": function() { return /* binding */ UpdateProductFavourite; },
/* harmony export */   "gV": function() { return /* binding */ getProductsCurations; },
/* harmony export */   "sx": function() { return /* binding */ CreateProductFavourite; }
/* harmony export */ });
/* harmony import */ var _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71287);

const UpdateProductFavourite = async (data, token)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.put */ .be.put("feed/product-fav/".concat(data.id, "/"), data, {
        headers: headers
    });
    return res;
};
const CreateProductFavourite = async (data, token)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(token);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.post */ .be.post("feed/product-fav/", data, {
        headers: headers
    });
    return res;
// return ;
};
const CreateProductView = async (data)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .AuthHeader */ .kP)();
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.post */ .be.post("feed/product_views_update/", data, {
        headers: headers
    });
    return res;
// return ;
};
const UpdateProductView = async (data)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .AuthHeader */ .kP)();
    // let res = await axiosInstance.put(`feed/product-view/${data.id}/`, data, { headers: headers })
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.post */ .be.post("feed/product_views_update/", data, {
        headers: headers
    });
    return res;
};
const getProductsCurations = async (id, page, session)=>{
    let headers = (0,_utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .setHeader */ .Ec)(session);
    let res = await _utility_AxoisConfig__WEBPACK_IMPORTED_MODULE_0__/* .axiosInstance.get */ .be.get("api/product-curation/".concat(id, "/"), {
        params: {
            page: page,
            page_size: 6
        },
        headers: headers
    });
    return res;
};


/***/ }),

/***/ 60187:
/***/ (function(module) {

module.exports = "/_next/static/images/Curly-hair-bro-525ff13caa7e225ca22a293773857906.png";

/***/ }),

/***/ 973:
/***/ (function(module) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAkCAYAAAA+TuKHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARuSURBVHgB3VpLctpAEG2NEJisuEHICUxOEHKCKCcI3iRlZxH7BMAJsBexq7IJPoHlE4ScIOQE0RGURco/0OS1ZgZkWRJCxmXgVYHQZ0S/6Y96umXRM+DMlU2b7hpTshoy+oSNtOsEWT5vbZKBQ46/51kBrRAWPRGYYEh3bSLZBImXkqiFw0yySSWBewQQ2Bck/SnRb4vscYVC/6NXHVMJrIT8d1c2rmnC5N5AxHYIopYimgtNJogJ4+vjPNaMbxa5D6xjBEu6FOSM9j1lMYtQmjwT/kc3HZvEuyyyRlP4jGHavyUJJjqGgEFRAQ3YkogmTeUmU/6/XYiPY5FFJYH/o5NFE7E0+TM3MuVuBmEmehkqgqNlCZYBK+GKpm2LwraMLO/+ZECeIb7P9z1nlBxbmLwhjT9oJ24wglYv61QbrjoglcGZe8XW4SJcfqGYy7Cc+O7HJ2Eh+TTS60DYaLxO9ihLBpYdcnYg8QdzTFmC02ertPJvPumC+GFs4Cg5e8+FU/dmqEmBhDWETP2sa5U1iF5sEoI6Oa+s7IvtC9L+w4FLEB3te9UhrQnO3NsO5IJyZqaNSXDe5sWZU3cCdwgH/DRBTHr9gPxX95YD2cX8pvK8TtXDdfDnNHx1b3rQfFfvQkaxd+BVvCJj75FnjYdk/5pH8fDowNs5pjWHttQfpBVmW6Lz6aJyvmiclXUDnNhbJzNfhKSrwhreLopNYv7TjvlPuFb+XQT7Xt2/gc/TLEuUF9/gwnljIs3rWfujDyByVvdoQ5GwYB9R/XVWvNKat7vzQ9mPjE0AWwCi+Xup1gzNK7rrZl0bkTcJjNL606ekT43PWOUh3TVKPFSJ2kOIAZIZ0r7Oiw/aEuinlF7qylTtix26ni1O9KpriyAi7bNlp2lfsI+YHSujorKp4GRHzuoF0k2ej3xe5ey8Fe9oy2CRvOStXu7eQ0Q+JPlTX9D6rmLA1kDq5z6lFD0i8rdUPdbm0ch7NGwmsp9eEfmjKAmQJ/pY5qNhM8Hlr3TM0lvWPs1Tw8G2mD8qx8bXxw/PabD2sRgwaW1rG8xfpbqzBC6bPINXQdB6PDPa8AnIT9tF8sBnr9bjAgb/xkT0NnUCWG5ovcO/s9J2kTbwwKt14hNw6t4OaIOgiMue3vV3yDlKuy63eouS1jEu+GJugqlAZadWqET0HOASHLQ5iFWac+t6C0vXp+71IXL+riltrVMF14ADG/u3MXMGywmNv8+rPRZqWqSUfhm8bu6/IMd7ruJmWk9BtcjCfpHa41LtqoxJQOCQ3rJNwjKItaa4P+jG22UqQ5UnL5CvFFXG0r06RmwSOIFoJk5zC3k8wXrBRguZqOKXmRDTmJyiKYlm6K5ucbdSCJTuHpUif1/IWUsobSLi8E0LGiutAP20pKBN05rmbV6L2xC2qOY9xtIeTT4OZRFOizum2N0t2qdfAB/mDAuSP/llhB2qjFcVY1ZKPg3mxYX56yfzhQa/sYHNXyypAyUMW4QI1Oso5dxlGfwH/5wJ+xNZJqkAAAAASUVORK5CYII="

/***/ }),

/***/ 5286:
/***/ (function(module) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACmSURBVHgBrZPvDYQgDMWfl/t+t8HhBo5wmziKuIErOIEj6EhuoAUrkoIR/7zkF2O15RVohk1fJkUj41QR00kqf2UT0IQSNEQfiWvOsY4Vv6iIVc0FpFzOCzf1TvjH2PwjdJBcoEC8DauUFgYiE+QxBwXCjfzhQH6BDvsOduW3kCO0WuNAt4/xkXuwDkVJtOL7B8s9UCJe8tMNlMb5YTI5dqNWXRrnGZhuL3eOAu05AAAAAElFTkSuQmCC"

/***/ }),

/***/ 97112:
/***/ (function(module) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD3SURBVHgBzZJBEsFAEEV/h7DkCNyAGzjCHIFlWIgTiBOkLLB1hLkBN+AIOUKsFKqMbpFRUlJJVvxFZibT/3VXTwO/FqWblbr2HCC8Az3+GRlgOdGNrdyt1UURaCp3HHME3JGnKbKAjTp37qgd+ND+pFMgq4EJMoljgtsXSF1ObPaz5hxjKo69+bz6TpLJtFFdLfk4SSaKUV0nC3BAGpWVeOwrbNR1x50flDMjGutG11bwIi5KmuV1RuneAjzt7rnrhRCJkdg3LKOVugScYZ5nnuhm8FnNF3E/hjx1YTob3JuYS515r8ksBCSQc4dQD81zRt6j+396ADixSgPZOYKLAAAAAElFTkSuQmCC"

/***/ }),

/***/ 56615:
/***/ (function(module) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADRSURBVHgBrVIBEcIwDAwcAiphEiahDpiDWZgD6gBQAA6QAA6Gg84Bc1CSkdxCably7O/+mvt+fl0bgD+xUnWFbJE1ckAeeSVY5BZpkGO0N4GaHsiA7FW9YwbWvKprHeCZlTrNgc2Ba6P2PIdMWsMmC59wyC6hW+5pNip5yASkIF6zhtelyNFKId6RAm7qWKVoeb2LcAV1KQVfp0s8xSIFXAoCyBMg8csdzG+fg8yEyxkcG/aRblj72hyHyGAR+9JmQQPz2MroWvgRFfIM72O8PJ6K8zxdUlHm1gAAAABJRU5ErkJggg=="

/***/ }),

/***/ 10689:
/***/ (function(module) {

module.exports = "/_next/static/images/Rectangle 3-92bea6907c4b8b3328c028c13043016b.png";

/***/ })

}]);